import { render, staticRenderFns } from "./bindmore.vue?vue&type=template&id=8690bdf0"
import script from "./bindmore.vue?vue&type=script&lang=js"
export * from "./bindmore.vue?vue&type=script&lang=js"
import style0 from "./bindmore.vue?vue&type=style&index=0&id=8690bdf0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports